<template>
  <interview-layout>
    <div style="max-width: 400px">
      <h1 class="px-4 text-primary fade-in-up-enter-active animation-slowest">
        Interesse
      </h1>
      <h5 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200">
        Salesforce interesse toevoegen
      </h5>

      <base-card
        class="w-100"
        inner-class="vw-100"
        color="alternate"
        :outer-padding="true"
      >
      
        <base-form @submit="onSubmit">
          <button-grid-input
            name="Interests"
            btn-direction="column"
            type="checkbox"
            btn-class="min-40"
            :pairs-mode="true"
            :distribute-equally="true"
            :options="interestOptions"
            variant="minimal-filled-info"
            inactiveVariant="minimal-dark"
            v-model:value="lead.interests.Interests"
            @update:value="updateInterests"
            :force-one-col="true"
          >
            Kies isolatieplan om deze interesse op te slaan.
          </button-grid-input>

          <button-row class="mt-4">
            <base-button class="ms-auto" icon="bi-arrow-right" type="submit">
              Volgende
            </base-button>
          </button-row>
        </base-form>
      </base-card>

      <button-row class="mt-2">
        <base-button
          variant="minimal-secondary"
          icon="bi-arrow-left"
          icon-position="start"
          @click="onPrev"
        >
          Terug
        </base-button>
      </button-row>
    </div>
  </interview-layout>
</template>

<script>
import InterviewLayout from "@/views/layouts/InterviewLayout.vue";
import BaseCard from "@/components/BaseCard.vue";
import BaseForm from "@/components/BaseForm.vue";
import BaseButton from "@/components/BaseButton.vue";
import ButtonRow from "@/components/ButtonRow.vue";
import { useAllStores } from "@/helpers/UseAllStores";
import { CommonComposable } from "@/helpers/CommonComposable";
import { FlowService } from "@/services/FlowService";
import ButtonGridInput from "@/components/ButtonGridInput.vue";

export default {
  components: {
    InterviewLayout,
    BaseCard,
    BaseForm,
    BaseButton,
    ButtonRow,
    ButtonGridInput,
  },
  setup(props, context) {
    return { ...CommonComposable(props, context), ...useAllStores() };
  },
  computed: {
    isolatieplanValue() {
      return "Isolatieplan Maatregel 29";
    },
    ondersteuningValue() {
      return "Ondersteuning Nij Begun";
    },
    gemeente() {
      return this.lead?.address?.Municipality || "";
    },
      interestOptions() {
        // Definitieve lijst gemeenten waar Ondersteuning Nij Begun getoond mag worden
        // const allowedMunicipalities = [
        //   'Veendam',
        //   'Groningen',
        //   'Eemsdelta',
        //   'Het Hogeland',
        //   'Midden-Groningen',
        //   'Oldambt',
        //   'Pekela',
        //   'Stadskanaal',
        //   'Westerwolde',
        // ];
        const options = [
          {
            label: "Isolatieplan",
            value: this.isolatieplanValue,
          }
        ];
        // if (allowedMunicipalities.includes(this.gemeente)) {
        //   options.push({
        //     label: "Ondersteuning Nij Begun",
        //     value: this.ondersteuningValue,
        //   });
        // }
        return options;
      },
  },
  methods: {
    updateInterests(values = []) {
      const allowed = [this.isolatieplanValue];
      this.lead.interests.Interests = Array.isArray(values)
        ? values.filter(v => allowed.includes(v))
        : [];
    },
    setInitialValue() {
      if (!Array.isArray(this.lead.interests?.Interests)) {
        this.lead.interests.Interests = [];
      }
    },
    onSubmit() {
      FlowService.pushNext(this);
    },
    onPrev() {
      FlowService.pushPrev(this);
    },
  },
  mounted() {
    this.setInitialValue();
  },
};
</script>
